import { getSelectedSchool, getSelectedSport } from 'app/imports/App.selectors'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function LayoutHeaderSchool() {
  const school = useSelector(getSelectedSchool)
  const selectedSport = useSelector(getSelectedSport)

  const title = useMemo(() => {
    if (!school || school.length === 0) return ''

    if (school.length > 1) return ''

    let result = school[0].shortName
    if (selectedSport && selectedSport.length > 0) {
      if (selectedSport.length === 1) {
        result += ` ${selectedSport[0].name}`
      }
    }

    return result
  }, [school, selectedSport])

  if (!school || school.length === 0) {
    return null
  }

  return (
    <>
      <title>{`Scoreboard | ${title}`}</title>
      {title}
    </>
  )
}
